import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  // Extraemos la ruta actual en la que se encuentra el usuario
  const { pathname } = useLocation();

  useEffect(() => {
    // Cada vez que el 'pathname' cambie, forzamos el scroll al inicio (X: 0, Y: 0)
    window.scrollTo(0, 0);
  }, [pathname]);

  // Este componente es invisible, no renderiza nada en la pantalla
  return null;
};

export default ScrollToTop;